import { Breakpoint, FontWeight, SimpleMarkdown, Typography, TypographyVariant } from '@elearning-platform/ui';
import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import {
  ContentWrapper,
  DescriptionContainer,
  HeaderContainer,
  Image,
  StyledHeaderTypography,
  Wrapper,
} from './centeredContentSlideWrapper.styled';
import { CenteredContentSlideWrapperProps } from './centeredContentSlideWrapper.types';

export const CenteredContentSlideWrapper: React.FC<CenteredContentSlideWrapperProps> = (
  props: CenteredContentSlideWrapperProps
): JSX.Element => {
  const {
    leftImageSrc,
    children,
    rightImageSrc,
    title,
    description,
    currentSlideCounter,
    slidesOverallCounter,
    fullWidth = false,
  }: CenteredContentSlideWrapperProps = props;
  const isSmallDesktop: boolean = useMediaQuery({ query: Breakpoint.SmallDesktop });
  const { t }: TransProps<never> = useTranslation();

  return (
    <Wrapper>
      {!!(isSmallDesktop && leftImageSrc) && <Image src={leftImageSrc} />}
      <ContentWrapper $fullWidth={fullWidth}>
        <HeaderContainer>
          <StyledHeaderTypography fontWeight={FontWeight.SemiBold} variant={TypographyVariant.TextSM}>
            <SimpleMarkdown
              text={t(
                'competence.app.scrollLesson.componentsV2.centeredContentSlideWrapper.slidesCounter',
                { currentSlideCounter, slidesOverallCounter }
              )}
            />
          </StyledHeaderTypography>
          <Typography fontWeight={FontWeight.Bold} variant={TypographyVariant.DisplayXS}>
            {title}
          </Typography>
        </HeaderContainer>
        {!!description && (
          <DescriptionContainer>
            <Typography variant={TypographyVariant.TextLG}>
              <SimpleMarkdown text={description} />
            </Typography>
          </DescriptionContainer>
        )}
        {children}
      </ContentWrapper>
      {!!(isSmallDesktop && rightImageSrc) && <Image src={rightImageSrc} />}
    </Wrapper>
  );
};
